import { useRef, useState, useEffect } from "react";

const AutoVideo = ({source, width}) => {


  return (
    <video
      src={source}
      autoPlay
      muted
      loop
      type="video/mp4"
      width="100%"
      height="100%"
    >
    </video>
  );
}

export default AutoVideo;